import {
  getPendingStopStatusWithDelayDuration,
  getMinutesInHourAndMinutesStr,
  getStopServiceWindow,
} from "../../util";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import constants from "./constants";
const PendingStopDelayedPopup = ({ task }) => {
  const { totalTime } = getPendingStopStatusWithDelayDuration(
    task.data,
    task.dispatchDate
  );
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      stopName={task?.data?.name}
      arrivalTimeLabel={constants.POPUP_LABELS.EST_ARRIVAL_TIME}
      arrivalTime={task.arrivalTime}
      departureTimeLabel={constants.POPUP_LABELS.EST_DEPARTURE_TIME}
      departureTime={task.departureTime}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      stopTimeLabel={constants.POPUP_LABELS.EST_STOP_TIME}
      statusLabel={constants.POPUP_LABELS.LATE_ARRIVAL}
      statusValue={totalTime ? totalTime : ""}
      stopStatusClass="violation"
      serviceWindow={getStopServiceWindow(task?.data)}
    />
  );
};

export default PendingStopDelayedPopup;
